// extracted by mini-css-extract-plugin
export default {"linea":"stylesCumpleanos_linea__oa+aG","icono":"stylesCumpleanos_icono__PRWUA"};